export default {"src":"/_next/static/media/residence-permit.806b3903.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};